import React, { Component } from 'react';
import { connect } from 'react-redux';

import Button from '../../../../components/Button';
import SearchHeader from '../../../../components/SearchHeader';
import AdminTable from '../../components/AdminTable';
import TagList from '../../components/AdminTable/TagList';
import LoadMask from '../../../../components/LoadMask';
import AddLuftUserModal from './AddLuftUserModal';
import EditLuftUserModal from './EditLuftUserModal';
import BatchEditLuftUserPermissionsModal from './BatchEditLuftUserPermissionsModal';

import { SUBSIDIARY_OPTIONS } from '../../shared/static-options';
import { fetchLuftUsers } from '../../../../redux/admin-luft-users';
import { getLuftUsersUI } from '../../../../redux/selectors';

const tableColumnNames = {
  NAME: 'name',
  EMAIL: 'email',
  SUBSIDIARIES: 'subsidiaries',
  ROLES: 'roles',
  EDIT: 'edit',
};

class AdminLuftUsers extends Component {
  constructor(props) {
    super(props);

    this.state = {
      addUserModal: {
        visible: false,
      },
      editUserModal: {
        visible: false,
        userData: null,
      },
      batchEditPermissionsModal: {
        visible: false,
        userDataList: null,
      },
      tableHeaders: [
        {
          name: tableColumnNames.NAME,
          label: 'Nome',
          boldPrimary: true,
        },
        {
          name: tableColumnNames.EMAIL,
          label: 'E-mail',
        },
        {
          name: tableColumnNames.SUBSIDIARIES,
          label: 'Filial',
        },
        {
          name: tableColumnNames.ROLES,
          label: 'Permissões',
        },
      ],
      tableActions: [
        {
          name: tableColumnNames.EDIT,
          label: 'Editar',
          iconName: 'mode_edit',
          actionFn: this._toggleEditLuftUserModal,
        },
      ],
    };
  }

  componentDidMount() {
    const { dispatch } = this.props;
    dispatch(fetchLuftUsers());
  }

  _onSearch = (searchValue) => {
    const { dispatch } = this.props;

    // Workaround to enable search for subsidiary column
    const subsidiaryMatched = SUBSIDIARY_OPTIONS.find(subsidiary =>
      subsidiary.label.toLocaleLowerCase().includes(searchValue.toLocaleLowerCase()));

    let searchVal = searchValue;
    if (subsidiaryMatched) searchVal = subsidiaryMatched.id;

    dispatch(fetchLuftUsers(searchVal));
  }

  _toggleAddLuftUserModal = () => {
    this.setState({
      addUserModal: {
        visible: !this.state.addUserModal.visible,
      },
    });
  }

  _toggleEditLuftUserModal = (userData) => {
    this.setState({
      editUserModal: {
        visible: !this.state.editUserModal.visible,
        userData: userData || null,
      },
    });
  }

  _toggleEditPermissionsModal = (userDataList) => {
    this.setState({
      batchEditPermissionsModal: {
        visible: !this.state.batchEditPermissionsModal.visible,
        userDataList: userDataList || null,
      },
    });
  }

  _renderBatchEdit = (selectedRows) => {
    if (!selectedRows) return null;

    return (
      <div className="luft-users-edit-multiple">
        <div className="luft-users-edit-multiple-counter">
          <span className="luft-users-edit-multiple-counter-number">{selectedRows.length}</span>
          <span className="luft-users-edit-multiple-counter-label">usuários selecionados</span>
        </div>
        <div className="luft-users-edit-multiple-buttons">
          <Button skin="primary" text="ALTERAR FILIAL" onClick={() => { }} />
          <Button skin="primary" text="EDITAR PERMISSÕES" onClick={() => this._toggleEditPermissionsModal(selectedRows)} />
          <Button skin="danger" text="REMOVER SELECIONADOS" onClick={() => { }} />
        </div>
      </div>
    );
  }

  _onRenderCell = (column, value) => {
    if (column === tableColumnNames.SUBSIDIARIES || column === tableColumnNames.ROLES) {
      return <TagList tagData={value} />;
    }
    return value;
  }

  render() {
    const {
      addUserModal,
      editUserModal,
      batchEditPermissionsModal,
      tableHeaders,
      tableActions,
    } = this.state;
    const { ui, luftUsers } = this.props;

    return (
      <div>
        <SearchHeader
          onSearch={this._onSearch}
          right={() =>
            <Button skin="primary" text="ADICIONAR USUÁRIO" onClick={this._toggleAddLuftUserModal} />
          }
        />
        <AdminTable
          errorMessage={ui.error}
          headers={tableHeaders}
          data={luftUsers}
          actions={tableActions}
          renderBatchEdit={this._renderBatchEdit}
          onRenderCell={this._onRenderCell}
          onRowSelect={this.onRowSelect}
        />
        {
          addUserModal.visible &&
          <AddLuftUserModal
            onDismiss={this._toggleAddLuftUserModal}
          />
        }
        {
          editUserModal.visible &&
          <EditLuftUserModal
            userData={editUserModal.userData}
            onDismiss={this._toggleEditLuftUserModal}
          />
        }
        {
          batchEditPermissionsModal.visible &&
          <BatchEditLuftUserPermissionsModal
            userDataList={batchEditPermissionsModal.userDataList}
            onDismiss={this._toggleEditPermissionsModal}
          />
        }
        {
          ui.isFetching &&
          <LoadMask text="Carregando..." />
        }
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
    ui: getLuftUsersUI(state),
    luftUsers: state.adminLuftUsers.luftUsers.data,
  };
}

export default connect(mapStateToProps)(AdminLuftUsers);
